<template>
    <div class="ProjectReport">
        <div class="metaHeader meta">
            <h1>Project Report</h1>
            <div class="third">
                <ReportMetaRow title="Dates" :value="dates" />
            </div>
        </div>

        <table class="main">
            <tbody v-for="(clientReport, index) in report.clientReports" :key="clientReport.client.id">
                <h2 :class="{ pageBreak: index !== 0 }">{{ clientReport.client.name }}</h2>
                <template v-for="(projectReport, index) in clientReport.projectReports">
                    <h3 :class="{ pageBreak: index !== 0 }">{{ projectReport.project.name }}</h3>
                    <table class="project">
                        <thead>
                            <tr>
                                <th>Ticket #</th>
                                <th>Date</th>
                                <th>Driver</th>
                                <th>Direct Hours</th>
                                <th>Indirect Hours</th>
                                <th>Total Hours</th>
                                <th>Total {{ isClarkLlc ? 'Cubic Yards' : 'Tons' }}</th>
                                <th>Total Loads</th>
                                <th>Backhaul Loads</th>
                                <th>Ticket Revenue</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="ticketReport in projectReport.ticketReports" :key="ticketReport.ticket.id">
                                <td width="5%">{{ ticketReport.ticket.ticketNumber }}</td>
                                <td width="10%">{{ formatDate(ticketReport.ticket.submittedAt, timeZone) }}</td>
                                <td width="35%">{{ `${ticketReport.ticket.user.firstName} ${ticketReport.ticket.user.lastName}` }}</td>
                                <td width="7%">{{ roundToNearestDecimalPlace(ticketReport.directHours) }}</td>
                                <td width="7%">{{ roundToNearestDecimalPlace(ticketReport.indirectHours) }}</td>
                                <td width="7%">{{ roundToNearestDecimalPlace(ticketReport.directHours + ticketReport.indirectHours) }}</td>
                                <td width="7%">{{ ticketReport.totalTons | formatTons }}</td>
                                <td width="7%">{{ ticketReport.ticket.loads.length }}</td>
                                <td width="7%">{{ ticketReport.ticket.loads.filter(l => l.isBackhaul).length }}</td>
                                <td width="15%">{{ ticketReport.revenue | formatCurrency }}</td>
                            </tr>
                            <tr class="footer">
                                <th colspan="3" class="projectTotal">
                                    <div>
                                        <div v-if="projectReport.totals.mobilizationPrice">
                                            <b>Mobilization:</b> {{ projectReport.totals.mobilizationPrice | formatCurrency }}
                                        </div>
                                        <div v-if="projectReport.totals.demobilizationPrice">
                                            <b>Demobilization:</b> {{ projectReport.totals.demobilizationPrice | formatCurrency }}
                                        </div>
                                    </div>
                                    <span>Project Total</span>
                                </th>
                                <td>{{ roundToNearestDecimalPlace(projectReport.totals.directHours) }}</td>
                                <td>{{ roundToNearestDecimalPlace(projectReport.totals.indirectHours) }}</td>
                                <td>{{ roundToNearestDecimalPlace(projectReport.totals.hours) }}</td>
                                <td>{{ projectReport.totals.tons | formatTons }}</td>
                                <td>{{ projectReport.totals.loads }}</td>
                                <td>{{ projectReport.totals.backhaulLoads }}</td>
                                <td>{{ projectReport.totals.revenue | formatCurrency }}</td>
                            </tr>
                            <tr v-if="index === clientReport.projectReports.length - 1" class="footer">
                                <th colspan="3">Client Total</th>
                                <td>{{ roundToNearestDecimalPlace(clientReport.totals.directHours) }}</td>
                                <td>{{ roundToNearestDecimalPlace(clientReport.totals.indirectHours) }}</td>
                                <td>{{ roundToNearestDecimalPlace(clientReport.totals.hours) }}</td>
                                <td>{{ clientReport.totals.tons | formatTons }}</td>
                                <td>{{ clientReport.totals.loads }}</td>
                                <td>{{ clientReport.totals.backhaulLoads }}</td>
                                <td>{{ clientReport.totals.revenue | formatCurrency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import { formatDate, roundToNearestDecimalPlace } from '@/utils/formatting';
import ReportMetaRow from './ReportMetaRow';

export default {
    name: 'ProjectReport',

    components: { ReportMetaRow },

    props: {
        report: { type: Object, required: true },
        timeZone: { type: String, required: true },
        isClarkLlc: { type: Boolean, default: false },
    },

    computed: {
        dates() {
            const startDate = formatDate(this.report.startAt, this.timeZone);
            const endDate = formatDate(this.report.endAt, this.timeZone);
            return `${startDate} - ${endDate}`;
        },
    },

    methods: {
        formatDate,
        roundToNearestDecimalPlace,
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ProjectReport {
    // Adds margin to the top of each page break
    thead:before {
        content: '';
        display: block;
        margin-top: $admin-gutter;
    }

    .metaHeader {
        margin-bottom: 40px;
    }

    .metaHeader h1 {
        float: left;
    }

    .metaHeader .third {
        float: right;
    }

    table.project {
        margin-bottom: 20px;
    }

    table.project td {
        height: 25px;
    }

    h2 {
        margin: 20px 0 10px;
    }

    h3 {
        margin-bottom: 10px;
    }

    .projectTotal > div {
        float: left;
        font-weight: 400;
    }

    .footer th {
        border: none;
        text-align: right;
    }
}
</style>
